import { Switch as AntdSwitch, SwitchProps } from 'antd';

type ISwitchProps = SwitchProps;

const Spinner = (props: ISwitchProps) => {
  return <AntdSwitch {...props} />;
};

export default Spinner;
